/* import __COLOCATED_TEMPLATE__ from './prism-info-circle-trigger.hbs'; */
import Component from '@ember/component';
export default Component.extend({
  tagName: '',
  isActive: false,
  activeClass: null
});